/* =========================================================
   Blog BETA timeline ticker. The shipping-status bar ([data-ev-card]) is
   Supabase-driven (blog_timeline + blog_settings) — there is no Shopify
   equivalent — so it loads client-side here. Lifted from blog-data.js' timeline
   renderer. Config: window.MP_BLOG (set in main-blog.liquid).
   ========================================================= */
(function () {
  "use strict";
  var card = document.querySelector("[data-ev-card]");
  if (!card) return;
  var cfg = window.MP_BLOG || {};
  if (!cfg.supabaseUrl || !cfg.anonKey || !window.supabase) return;
  var sb = window.supabase.createClient(cfg.supabaseUrl, cfg.anonKey);

  var timeline = [], tracker = null, postIdToSlug = {};

  function esc(s){return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");}
  function fmtDate(iso){try{return new Date(iso).toLocaleDateString(undefined,{month:"short",day:"numeric",year:"numeric"});}catch(e){return "";}}

  var caret='<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>';
  var arrowL='<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>';
  var arrowR='<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>';

  function goLink(slug){ return slug ? '<a class="tl-go" href="#post-'+esc(slug)+'" data-jump="'+esc(slug)+'">Read update <span aria-hidden="true">→</span></a>' : ""; }
  function tlData(){
    var t=tracker||{};
    return {
      evs: timeline.map(function(ev){return {date: ev.date_label||(ev.event_on?fmtDate(ev.event_on):""), label: ev.label||"", desc: ev.description||"", slug: ev.linked_post_id?postIdToSlug[ev.linked_post_id]:null};}),
      estLabel: t.est_label||"Est. shipping", estDate: t.est_date||"", prodLabel: t.production_label||"", pct: Math.max(0,Math.min(100,t.production_pct||0))
    };
  }
  function tickerItem(e){return '<em class="cf-tk-date">'+esc(e.date)+"</em> "+esc(e.label);}
  var tickerTimer=null;
  function startTicker(el,evs){
    if(tickerTimer){clearInterval(tickerTimer);tickerTimer=null;}
    if(!el||evs.length<=1)return;
    var i=evs.length-1;
    tickerTimer=setInterval(function(){ i=(i+1)%evs.length; el.classList.add("is-out"); setTimeout(function(){el.innerHTML=tickerItem(evs[i]);el.classList.remove("is-out");},240); },3600);
  }
  function clhRail(d){
    var cards=d.evs.map(function(e,i){var latest=i===d.evs.length-1;return '<li class="clh-ev'+(latest?" is-latest":"")+'"><div class="clh-card"><span class="clh-head"><span class="clh-mark"></span><span class="clh-date">'+esc(e.date)+'</span></span><span class="clh-label">'+esc(e.label)+'</span><span class="clh-desc">'+esc(e.desc||"")+'</span>'+goLink(e.slug)+'</div></li>';}).join("");
    return '<div class="cf-panel" data-tl-panel hidden><div class="clh-wrap"><button type="button" class="clh-arrow clh-arrow--prev" data-rail-prev aria-label="Previous updates">'+arrowL+'</button><ol class="clh-rail" data-ts-rail>'+cards+'</ol><button type="button" class="clh-arrow clh-arrow--next" data-rail-next aria-label="More updates">'+arrowR+'</button></div></div>';
  }
  function wireRail(rail){
    if(!rail)return;
    rail.addEventListener("wheel",function(e){if(Math.abs(e.deltaY)<=Math.abs(e.deltaX))return;var max=rail.scrollWidth-rail.clientWidth;if(max<=0)return;rail.scrollLeft+=e.deltaY;e.preventDefault();},{passive:false});
    var down=false,sx=0,sl=0,moved=false;
    rail.addEventListener("pointerdown",function(e){down=true;moved=false;sx=e.clientX;sl=rail.scrollLeft;rail.classList.add("is-grabbing");try{rail.setPointerCapture(e.pointerId);}catch(err){}});
    rail.addEventListener("pointermove",function(e){if(!down)return;var dx=e.clientX-sx;if(Math.abs(dx)>4)moved=true;rail.scrollLeft=sl-dx;});
    function end(){down=false;rail.classList.remove("is-grabbing");}
    rail.addEventListener("pointerup",end);rail.addEventListener("pointercancel",end);
    rail.addEventListener("click",function(e){if(moved){e.preventDefault();e.stopPropagation();moved=false;}},true);
    var wrap=rail.parentNode,prev=wrap.querySelector("[data-rail-prev]"),next=wrap.querySelector("[data-rail-next]"),step=240;
    if(prev)prev.addEventListener("click",function(){rail.scrollBy({left:-step,behavior:"smooth"});});
    if(next)next.addEventListener("click",function(){rail.scrollBy({left:step,behavior:"smooth"});});
    function upd(){var max=rail.scrollWidth-rail.clientWidth;if(prev)prev.classList.toggle("is-off",rail.scrollLeft<=1);if(next)next.classList.toggle("is-off",rail.scrollLeft>=max-1||max<=0);}
    rail.addEventListener("scroll",upd);requestAnimationFrame(upd);
  }
  function tlFinal(d){
    var latest=d.evs.length?d.evs[d.evs.length-1]:null;
    return '<div class="cf"><div class="cf-mob"><span class="cf-mob-prod"><span class="tl-live"></span>'+esc(d.prodLabel||"In production")+'</span><span class="cf-mob-eta"><span class="cf-eta-k">'+esc(d.estLabel)+'</span> <b>'+esc(d.estDate||"—")+'</b></span></div><div class="cf-prod"><span class="tl-live"></span><span class="cf-prod-label">'+esc(d.prodLabel||"In production")+'</span></div><button type="button" class="cf-ticker" data-tl-toggle aria-expanded="false"><span class="cf-tk-eyebrow">Updates · '+d.evs.length+'</span><span class="cf-tk-roll" data-ticker>'+(latest?tickerItem(latest):"")+'</span><span class="cf-tk-caret">'+caret+'</span></button><div class="cf-eta"><span class="cf-eta-k">'+esc(d.estLabel)+'</span><b>'+esc(d.estDate||"—")+'</b></div></div>'+clhRail(d);
  }
  function render(){
    if(!timeline.length && !tracker){ card.hidden=true; return; }
    card.hidden=false;
    var d=tlData();
    card.className="tl tl--final";
    card.innerHTML=tlFinal(d);
    var tk=card.querySelector("[data-ticker]"); if(tk)startTicker(tk,d.evs);
    wireRail(card.querySelector("[data-ts-rail]"));
    var toggle=card.querySelector("[data-tl-toggle]");
    if(toggle)toggle.addEventListener("click",function(){
      var panel=card.querySelector("[data-tl-panel]"); if(!panel)return;
      var open=panel.hasAttribute("hidden");
      if(open){panel.removeAttribute("hidden");var rail=panel.querySelector("[data-ts-rail]");if(rail)requestAnimationFrame(function(){rail.scrollLeft=rail.scrollWidth;});}else panel.setAttribute("hidden","");
      card.classList.toggle("is-open",open);
      toggle.setAttribute("aria-expanded",open?"true":"false");
    });
  }

  (async function load(){
    try{
      var res=await Promise.all([
        sb.from("blog_timeline").select("id,event_on,date_label,label,description,linked_post_id").order("event_on",{ascending:true}),
        sb.from("blog_settings").select("est_label,est_date,production_label,production_pct").eq("id",true).maybeSingle(),
        sb.from("blog_posts").select("id,slug").eq("status","published")
      ]);
      timeline=res[0].data||[];
      tracker=res[1].data||null;
      (res[2].data||[]).forEach(function(p){postIdToSlug[p.id]=p.slug;});
    }catch(e){ return; }
    render();
  })();
})();
